import { createFileRoute } from "@tanstack/react-router";
import HelpingSomeoneWithDepression from "@/pages/HelpingSomeoneWithDepression";
export const Route = createFileRoute("/helping-someone-with-depression")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Helping Someone With Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How to help a loved one with depression: warning signs, what to say, and treatment options like TMS and SAINT TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Helping Someone With Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How to help a loved one with depression: warning signs, what to say, and treatment options like TMS and SAINT TMS in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/helping-someone-with-depression",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/helping-someone-with-depression",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HelpingSomeoneWithDepression />;
}
